import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePageTitle } from 'utils/pageTitle';
import { checkAuthToken, unsubscribeByToken } from 'reducers/tempAuthTokenReducer';

import Spinner from 'components/Spinner';


import "./Unsubscribe.css"

const Unsubscribe = (props) => {
	const dispatch = useDispatch();
	const {
		isLoading,
		tokenData,
		hasError,
		tokenString,
		unsubSuccess,
		unsubError,
	} = useSelector(state => ({
		isLoading: state.tempAuthToken.isLoading,
		tokenData: state.tempAuthToken.token,
		hasError: state.tempAuthToken.hasError,
		tokenString: state.router.location.query?.token,
		unsubSuccess: state.tempAuthToken.unsubSuccess,
		unsubError: state.tempAuthToken.unsubError,
	}));
	usePageTitle('Unsubscribe');
	const [isUnsubChecked, setIsUnsubChecked] = useState(false);

	// console.log('tokenData', tokenData)

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		dispatch(checkAuthToken(tokenString));
	}, [tokenString]);


	const invalidTokenContent = (
		<div className="unsub-message">
			<i className="bi bi-emoji-frown" />
			<h3>Oops, looks like this link is invalid</h3>
		</div>
	);

	// const expiredContent = (
	// 	<div className="unsub-message">
	// 		<i className="bi bi-emoji-frown" />
	// 		<h3>Oops, looks like this link is expired</h3>
	// 	</div>
	// );

	const successContent = (
		<div className="unsub-message">
			<h3>You've been successfully unsubscribed from email messaging.</h3>
			<div>You can sign back up to receive emails at any time</div>
		</div>
	);

	const failContent = (
		<div className="unsub-message">
			<i className="bi bi-emoji-frown" />
			<h3>Oops, something went wrong</h3>
		</div>
	);

	const onUnsub = () => {
		if (isUnsubChecked) {
			dispatch(unsubscribeByToken(tokenString));
		}
	}

	const unsubContent = (
		<div>
			<div className="form-group form-check">
				<input
					type="checkbox"
					className="form-check-input"
					id={`unsubscribe`}
					value={isUnsubChecked || false}
					checked={isUnsubChecked || false}
					onChange={(ev) => setIsUnsubChecked(ev.target.checked)}
				/>
				<label className="form-check-label" htmlFor={`unsubscribe`}>Unsubscribe from all emails</label>
			</div>
			<button className="btn btn-primary" disabled={!isUnsubChecked} onClick={onUnsub}>
				Unsubscribe
			</button>
		</div>
	);

	let content = null;

	if (isLoading) {
		content = <Spinner />;
	} else if (hasError) {
		content = invalidTokenContent;
	} else if (unsubSuccess) {
		content = successContent;
	} else if (unsubError) {
		content = failContent;
	} else if (tokenData) {
		content = unsubContent;
	}


	return (	
		<div className="unsubscribe-page">
				<h2 className="">
					Email Preferences
				</h2>
				<div className="card-body">
					{content}
				</div>
			
		</div>
	);
}

export default Unsubscribe;
